// useBatchQrcode.ts
import { ref, nextTick } from 'vue'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import QRCode from 'qrcode'
/**
 *
 * @param qrCodeData  二维码urll 数组
 * @param snList sn 数组
 * @param nameList
 * @returns
 */
export const useBatchQrcode = (): any => {
  const isGenerating = ref(false)
  const previewCanvas = ref<HTMLCanvasElement | null>(null)

  const generateQRCodes = async (qrCodeData: string[] = []): Promise<string[]> => {
    console.log('generateQRCodes', qrCodeData)
    return await Promise.all(qrCodeData.map((data) => QRCode.toDataURL(data)))
  }
  const truncateText = (ctx: CanvasRenderingContext2D, text: string, maxWidth: number) => {
    const ellipsis = '...'
    let textWidth = ctx.measureText(text).width
    if (textWidth <= maxWidth) return text

    while (text.length > 0 && textWidth + ctx.measureText(ellipsis).width > maxWidth) {
      text = text.slice(0, -1)
      textWidth = ctx.measureText(text).width
    }
    return text + ellipsis
  }
  /**
   * canvas paint function to paint the canvas with qrcode and text
   * @param canvas
   * @param qrCodeImage
   * @param texts
   */
  const paintCanvas = async (
    canvas: HTMLCanvasElement,
    qrCodeImage: string,
    sn: string,
    name: string,
  ) => {
    const ctx = canvas.getContext('2d')
    if (!ctx) return

    canvas.width = 550
    canvas.height = 550
    const _qrcode_w = 450
    const _qrcode_h = 450

    ctx.fillStyle = '#fff'
    ctx.fillRect(0, 0, canvas.width, canvas.height)

    await new Promise<void>((resolve) => {
      const qrImage = new Image()
      qrImage.src = qrCodeImage
      qrImage.onload = () => {
        ctx.drawImage(qrImage, (canvas.width - _qrcode_w) / 2, 20, _qrcode_w, _qrcode_h)
        resolve()
      }
    })

    ctx.fillStyle = '#000'
    ctx.font = '30px Arial'
    const _sn = truncateText(ctx, sn, canvas.width - 40)
    const _snWidth = ctx.measureText(_sn).width
    const _name = truncateText(ctx, name, canvas.width - 40)
    const _nameWidth = ctx.measureText(_name).width
    ctx.fillText(_sn, (canvas.width - _snWidth) / 2, _qrcode_h + 40)
    // ctx.fillText(_name, (canvas.width - _nameWidth) / 2, _qrcode_h + 40)
  }

  const generatePreview = async (url: string, sn: string, name: string) => {
    if (!name.length || !url.length) return
    const qrCodeImages = await generateQRCodes([url])
    if (!previewCanvas.value) return
    const canvas = previewCanvas.value
    paintCanvas(canvas, qrCodeImages[0], sn || '', name || '')
  }

  const downloadZip = async (qrCodeData: string[], snList: string[], nameList: string[]) => {
    // console.log('downloadZip', qrCodeData, snList, nameList)
    if (!qrCodeData.length) return
    isGenerating.value = true

    try {
      const qrCodeImages = await generateQRCodes(qrCodeData)
      const zip = new JSZip()
      for (let i = 0; i < qrCodeData.length; i++) {
        await nextTick()
        const canvas = document.createElement('canvas')
        await paintCanvas(canvas, qrCodeImages[i], snList[i] || '', nameList[i] || '')
        const imageData = canvas.toDataURL('image/png')
        zip.file(`${nameList[i]}_${snList[i]}_${i + 1}.png`, imageData.split(',')[1], {
          base64: true,
        })
      }
      const content = await zip.generateAsync({ type: 'blob' })
      saveAs(content, 'qr-code.zip')
    } catch (e) {
      console.log('downloadZip error', e)
    }

    isGenerating.value = false
  }

  return { previewCanvas, isGenerating, generatePreview, downloadZip }
}
